export const api = 'https://json-server-rho-lovat.vercel.app/aluraflix'
